import { createSlice } from "@reduxjs/toolkit";

const viajesState = {
  viajesdata: [],
};

const viajesSlice = createSlice({
  name: "viajes",
  initialState: viajesState,
  reducers: {
    viajesData: (state, actions) => actions.payload,
    CleanViajesData: () => viajesState,
  },
});

export const { viajesData, CleanViajesData } = viajesSlice.actions;

export default viajesSlice.reducer;
